
import jQuery from "jquery";
let $ = jQuery;
import db from "@/components/firebaseInit";
import firebase from "firebase";
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import common from "@/common";

Vue.use(VueMoment, {
	moment,
});

let qnaDBRef;
let vm;
export default {
	sessionTypeId: 0,
	sessionId: "",
	roomId: "",
	roundTableId: "",
	uid: "",
	userType: 0,
	QnAModeration: false,
	QnAAutoPublish: false,
	name: "",
	profileImage: "",
	channelName: "",
	qnaCollectionName: "",
	allQnAs: [],
	oldQnALoaded: false,
	isQnAPanelOpend: false,
	unreadQnACount: 0,

	initQnA(sessionTypeId, sessionId, roundTableId, uid, userType, QnAModeration, QnAAutoPublish, roomId, eventCollectioNname) {
		vm = this;
		vm.initVars();

		let myApp = window.localStorage.getItem("my-app");
		myApp = myApp == undefined ? "" : myApp;
		myApp = myApp == null ? "" : myApp;
		var obj = JSON.parse(myApp);

		if (obj != undefined && obj != null) {
			vm.qnaCollectionName = obj.eventcollectionname;
			if (!vm.qnaCollectionName) {
				vm.qnaCollectionName = eventCollectioNname;
			}
			vm.uid = obj.user[0].id;
			vm.name = obj.user[0].name;
			vm.profileImage = obj.user[0].profilepic;
		}
		if (vm.qnaCollectionName != "") {
			vm.sessionTypeId = sessionTypeId;
			vm.sessionId = sessionId;
			vm.roundTableId = roundTableId;
			if (uid != undefined && uid != "") {
				vm.uid = uid;
			}
			if (userType != undefined && userType != 0) {
				vm.userType = userType;
			}
			if (QnAModeration) {
				vm.QnAModeration = QnAModeration;
			}
			if (QnAAutoPublish) {
				vm.QnAAutoPublish = QnAAutoPublish;
			}
			if (roomId) {
				vm.roomId = roomId;
			}
			if (vm.sessionTypeId == 4) {
				vm.qnaCollectionName += "/UserVideoActivity/RoundTable";
				vm.qnaCollectionName += "/" + vm.roundTableId;
				if (!vm.roomId) {
					vm.qnaCollectionName += "/QnA";
				} else {
					vm.qnaCollectionName += "/BreakoutRooms/" + vm.roomId + "/QnA";
				}
			}
			else {
				vm.qnaCollectionName += "/UserVideoActivity/Session";
				vm.qnaCollectionName += "/" + vm.sessionId;
				if (!vm.roomId) {
					vm.qnaCollectionName += "/QnA";
				} else {
					vm.qnaCollectionName += "/BreakoutRooms/" + vm.roomId + "/QnA";
				}
			}
			if (qnaDBRef) {
				qnaDBRef();
			}
			qnaDBRef = db
				.collection(vm.qnaCollectionName)
				.onSnapshot((snapshot) => {
					let changes = snapshot.docChanges();
					let qnaCount = 0;
					changes.forEach(function (change) {
						//alert(change.type);
						let data = change.doc.data();
						data.CreatedDateS = data.CreatedDate.seconds;
						data.CreatedDateStr = vm.formatDatetime(data.CreatedDate);
						data.myQnA = data.CreatedBy == vm.uid;
						//if (data.QnAId == "1602760780855") {
						//	alert()
						//}
						//if (!data.Approved) {
						//	if (!vm.QnAModeration && !vm.QnAAutoPublish) {
						//		data.Approved = true;
						//	}
						//}
						if (data.IsAnonymous) {
							data.Name = "Anonymous";
							data.ProfilePictureURL = "";
						}
						if (change.type == "added") {
							if (vm.oldQnALoaded) {
								data.read = false;
							}
							else {
								data.read = true;
							}
							if (!data.ProfilePictureURL) {
								data.ProfilePictureURL = "";
							}
							data.NameInitial = common.getInitials(data.Name);
							if (data.LikeAttendees) {
								data.IsLiked = data.LikeAttendees.includes(vm.uid);
							}
							else {
								data.IsLiked = false;
							}
							if (vm.userType == 4) {
								if (data.IsPublished) {
									//if (data.CreatedBy == vm.uid) {
									//	data.UaserClass = "right-align";
									//}
									//else {
									//	data.UaserClass = "";
									//}
									vm.allQnAs.push(data);
									qnaCount++;
								}
							}
							else {
								if (data.Approved) {
									vm.allQnAs.push(data);
									qnaCount++;
								}
							}
						}
						else if (change.type == "modified") {
							debugger
							vm.allQnAs.map(function (item) {
								if (item.QnAId == data.QnAId) {
									item.read = false;
									item.TotalLikes = data.TotalLikes;
									if (data.LikeAttendees) {
										item.IsLiked = data.LikeAttendees.includes(vm.uid);
									}
									else {
										item.IsLiked = false;
									}
								}
							});

							if (vm.userType == 1) {
								if (data.Approved) {
									vm.allQnAs.map(function (item) {
										if (item.QnAId == data.QnAId) {
											item.IsPublished = data.IsPublished;
											item.TotalLikes = data.TotalLikes;
										}
									});
									let qnas = vm.allQnAs.filter(function (item) {
										return item.QnAId == data.QnAId;
									});
									if (qnas.length == 0) {
										data.NameInitial = common.getInitials(data.Name);
										data.read = false;
										vm.allQnAs.push(data);
										qnaCount++;
									}
								}
								else {
									vm.allQnAs = vm.allQnAs.filter(function (item) {
										return item.Approved;
									});
								}
							}
							else {
								if (data.IsPublished) {
									let qnas = vm.allQnAs.filter(function (item) {
										return item.QnAId == data.QnAId;
									});
									if (qnas.length == 0) {
										data.NameInitial = common.getInitials(data.Name);
										vm.allQnAs.push(data);
										qnaCount++;
									}
								}
								else {
									vm.allQnAs = vm.allQnAs.filter(function (item) {
										return item.QnAId != data.QnAId;
									});
								}
							}
						}
						//else if (change.type == "removed") {
						//}
					});

					vm.allQnAs = vm.allQnAs.filter(function () {
						return true;
					});
					if (vm.oldQnALoaded) {
						//let changesCount = changes.length;
						//console.log(qnaCount)
						//if (!vm.isQnAPanelOpend) {
						if (!$("#btn_qa").hasClass("active")) {
							vm.unreadQnACount += qnaCount;
						}
					}
					vm.oldQnALoaded = true;
				});
			//.catch(function (error) {
			//	console.error("Error creating speaker: ", error);
			//});
		}
	},

	initVars() {
		vm.sessionTypeId = 0;
		vm.sessionId = "";
		vm.roomId = "";
		vm.roundTableId = "";
		vm.uid = "";
		vm.userType = 0;
		vm.QnAModeration = false;
		vm.QnAAutoPublish = false;
		vm.name = "";
		vm.profileImage = "";
		vm.channelName = "";
		vm.qnaCollectionName = "";
		vm.allQnAs = [];
		vm.oldQnALoaded = false;
		vm.isQnAPanelOpend = false;
		vm.unreadQnACount = 0;
	},

	addQnA(msg, postAnonymous, isQnATabVisible, isQnAPanelOpend) {
		let isApproved = false;
		let isPublished = false;
		if (!vm.QnAModeration && !vm.QnAAutoPublish) {
			isApproved = true;
			isPublished = true;
		}
		//else if (!vm.QnAAutoPublish) {
		//	isPublished = true;
		//	isApproved = true;
		//}

		if (!vm.name || !vm.profileImage) {
			let myApp = window.localStorage.getItem("my-app");
			if (myApp) {
				var obj = JSON.parse(myApp);
				if (obj.user[0].name) {
					vm.name = obj.user[0].name;
				}
				if (obj.user[0].profilepic) {
					vm.profileImage = obj.user[0].profilepic;
				}
			}
			// let user = vm.getSessionUserProfile();
			// if (user.Name) {
			// 	vm.name = user.Name;
			// }
			// if (user.ProfileImageURL) {
			// 	vm.profileImage = user.ProfileImageURL;
			// }
		}
		if (isQnATabVisible && isQnAPanelOpend) {
			let qnaId = new Date().getTime().toString();
			let qnaObj = new Object({
				Answer: "",
				Answered: false,
				Approved: isApproved,
				CreatedBy: vm.uid,
				CreatedDate: new Date(),
				IsAnonymous: postAnonymous,
				IsPublished: isPublished,
				LastModifiedDate: new Date(),
				ModifiedBy: vm.uid,
				Name: vm.name,
				ProfilePictureURL: vm.profileImage,
				QnAId: qnaId,
				Question: msg,
				SessionId: vm.sessionId,
				SessionName: "",
				TotalDislikes: 0,
				TotalLikes: 0,
			});
			db.collection(vm.qnaCollectionName)
				.doc(qnaId).set(qnaObj).then(function () {
					//alert("Success QNA Post")
				});
		}
	},

	toggleLikeQnA(qnaId, isLiked) {
		//alert("likeQnA")
		if (qnaId != "") {
			db.collection(vm.qnaCollectionName)
				.doc(qnaId)
				.get()
				.then((doc) => {
					if (doc.exists) {
						let data = doc.data();
						if (data && data.IsPublished) {
							if (isLiked) {
								if (data.LikeAttendees && data.LikeAttendees.includes(vm.uid)) {
									db.collection(vm.qnaCollectionName)
										.doc(qnaId)
										.update({
											TotalLikes: firebase.firestore.FieldValue.increment(-1),
											LikeAttendees: firebase.firestore.FieldValue.arrayRemove(vm.uid),
											LastModifiedDate: new Date()
										})
										.then(function () {
											console.log(" : ");
										})
										.catch(function (error) {
											console.error("Error : ", error);
										});
								}
							}
							else {
								if (!data.LikeAttendees || !data.LikeAttendees.includes(vm.uid)) {
									db.collection(vm.qnaCollectionName)
										.doc(qnaId)
										.update({
											TotalLikes: firebase.firestore.FieldValue.increment(1),
											LikeAttendees: firebase.firestore.FieldValue.arrayUnion(vm.uid),
											LastModifiedDate: new Date()
										})
										.then(function () {
											console.log(" : ");
										})
										.catch(function (error) {
											console.error("Error : ", error);
										});
								}
							}
						}
					}
				});
		}
	},

	togglePublishQnA(qnaId, isPublished) {
		//alert("togglePublishQnA")
		if (qnaId != "") {
			db.collection(vm.qnaCollectionName)
				.doc(qnaId)
				.get()
				.then((doc) => {
					if (doc.exists) {
						let data = doc.data();
						if (data) {// && data.Approved && !data.Answered
							if (isPublished) {
								db.collection(vm.qnaCollectionName)
									.doc(qnaId)
									.update({
										IsPublished: false,
										LastModifiedDate: new Date(),
										ModifiedBy: vm.uid
									})
									.then(function () {
										console.log(" : ");
									})
									.catch(function (error) {
										console.error("Error : ", error);
									});
							}
							else {
								db.collection(vm.qnaCollectionName)
									.doc(qnaId)
									.update({
										IsPublished: true,
										LastModifiedDate: new Date(),
										ModifiedBy: vm.uid
									})
									.then(function () {
										console.log(" : ");
									})
									.catch(function (error) {
										console.error("Error : ", error);
									});
							}
						}
					}
				});
		}
	},

	formatDatetime(date) {
		let today = moment(new Date).format("MMM DD, ");
		let datetime = new Date(date.seconds * 1000)
		let dateStr = moment(datetime).format("MMM DD, HH:mm");
		return dateStr.replace(today, "");
	},
};